import axios from "axios";

const BASE_URL = "https://lms.childinfo.in/api";

export const getStudents = (token) => {
  return axios.get(`${BASE_URL}/students.php`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateStudent = (token, id, payload) => {
  return axios.put(`${BASE_URL}/students.php?id=${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
